import { createContext, useEffect, useState } from "react";
import chatDefaultBackground from "../img/chatroombg.png";

export const ChatContext = createContext();

export const ChatProvider = ({children}) =>{
    const [replyData, setReplyData] = useState({isReplyClicked: "", displayName:"", message:"", chatImage:"", audioDuration:""});
    const [chatWallpaper,setWallpaper] = useState("");
    const getWallpaperItem = localStorage.getItem("wallpaper");

    const handleReply = (isReplyClicked, displayName, message, chatImage, audioDuration) =>{
        setReplyData({isReplyClicked, displayName, message, chatImage, audioDuration})
    };

    const handleSetWallpaper=(image,title)=>{
      const item =  localStorage.setItem("wallpaper",image);
      setWallpaper(item);
      alert(`${title} is applied successfully`);
    };

    useEffect(()=>{
        if (getWallpaperItem && getWallpaperItem !== "") {
          setWallpaper(getWallpaperItem);
        }else{
          setWallpaper(chatDefaultBackground);
        }
      },[getWallpaperItem]);

    return(
        <ChatContext.Provider value={{
            replyData,
            handleReply,
            chatWallpaper,
            handleSetWallpaper,
        }}>
            {children}
        </ChatContext.Provider>
    )
}